
var funcShowSubMenu = function(){
	$(this).children("ul").addClass("open-sub-menu"); //Abre o sub-menu
}

var funcShowMultiLevel = function(){
	$(this).children("ul").addClass("open-multi-level"); //Abre sub-menu com mais de um nível
}

var funcHideSubMenu = function(){
	$(this).children("ul").removeClass("open-sub-menu open-multi-level");
}

$(".menu > li").focusin(funcShowSubMenu).focusout(funcHideSubMenu);
$(".sub-menu > li").focusin(funcShowMultiLevel).focusout(funcHideSubMenu);
